import { render, staticRenderFns } from "./SelectModalOptions.vue?vue&type=template&id=f8520dfa&scoped=true"
import script from "./SelectModalOptions.vue?vue&type=script&lang=js"
export * from "./SelectModalOptions.vue?vue&type=script&lang=js"
import style0 from "./SelectModalOptions.vue?vue&type=style&index=0&id=f8520dfa&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8520dfa",
  null
  
)

export default component.exports